interface SelectionBarProps {
  count: number;
  totalCount: number;
  itemLabel: string; // "file" or "folder"
  onSelectAll: () => void;
  onClearSelection: () => void;
  onDeleteSelected: () => void;
  deleting?: boolean;
  selectAllLabel?: string;
}

export function SelectionBar({
  count,
  totalCount,
  itemLabel,
  onSelectAll,
  onClearSelection,
  onDeleteSelected,
  deleting,
  selectAllLabel = 'Select All',
}: SelectionBarProps) {
  const label = count === 1 ? itemLabel : `${itemLabel}s`;
  return (
    <div className="selection-bar">
      <span className="selection-bar-count">
        {count} {label} selected
      </span>
      <div className="selection-bar-actions">
        {count < totalCount && (
          <button className="btn-small btn-ghost" onClick={onSelectAll}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <polyline points="7 12 10 15 17 6" strokeWidth="3" />
            </svg>
            {selectAllLabel}
          </button>
        )}
        <button className="btn-small btn-ghost" onClick={onClearSelection}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
          Clear
        </button>
        <button
          className="btn-small btn-danger"
          onClick={onDeleteSelected}
          disabled={deleting}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
          </svg>
          {deleting ? 'Deleting...' : 'Delete'}
        </button>
      </div>
    </div>
  );
}
